import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ResultApi } from '../viewModel/result_api.model';

@Injectable({
    providedIn: 'root'
})
export class RdstationService {

    constructor(private httpClient: HttpClient) {}

    public async indicar(body: any): Promise<ResultApi> {
        try {
            const httpOptions = {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
                    'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token'
                })
            };

            return this.httpClient
                .post<any>(`https://api.rd.services/platform/conversions?api_key=NiNyIHZJsBTDseftsmQZFRudOPjUEBMyXMeR`, body, httpOptions)
                .toPromise()
                .then((res: any) => {
                    if (res) {
                        return new ResultApi().toResult({ status: 200, data: res, error: null });
                    }
                    return null;
                })
                .catch((err: any) => {
                    return new ResultApi().toResult({ status: 200, data: null, error: err });
                });
        } catch (e) {
            return null;
        }
    }

    public async landingPost(body: any): Promise<ResultApi> {
        try {
            const httpOptions = {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
                    'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token'
                })
            };

            return this.httpClient
                .post<any>(`https://www.rdstation.com.br/api/1.2/conversions`, body, httpOptions)
                .toPromise()
                .then((res: any) => {
                    if (res) {
                        return new ResultApi().toResult({ status: 200, data: res, error: null });
                    }
                    return null;
                })
                .catch((err: any) => {
                    return new ResultApi().toResult({ status: 200, data: null, error: err });
                });
        } catch (e) {
            return null;
        }

  }
}
